import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SsoCallbackComponent } from './sso-callback.component';

const routes: Routes = [
  {
    path: '',
    component: SsoCallbackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SsoCallbackRoutingModule {}
